// Shared by the browser, dev server and Lambda@Edge. Use the same locale manifest everywhere.
import { isSupportedLocale } from './locales.js';

export const isEntityId = (value) =>
  /^[1-9]\d*$/.test(String(value)) && Number.isSafeInteger(Number(value));

// Ungrouped offers use the stable public identity groupId = -tourId.
export const isGroupId = (value) =>
  /^-?[1-9]\d*$/.test(String(value)) && Number.isSafeInteger(Number(value));

// Human-readable suffixes such as "san-francisco" and "czechia" are not ID tokens.
export const isNumericRouteToken = (value, prefix) =>
  typeof value === 'string' && new RegExp(`^${prefix}(?:$|[^a-z])`, 'i').test(value);

export const hasMalformedEntityPath = (path) => {
  const [, language, entity, child] = path.split('?')[0].split('/');
  // Asset names such as /images/placeholder-large.png are not localized entity routes.
  if (!language || !isSupportedLocale(language.toLowerCase())) return false;
  if (!entity || ['destinations', 'privacypolicy', 'termsandconditions'].includes(entity)) {
    return false;
  }
  if (!/^[dpgt]/.test(entity)) return false;
  const validId = entity.startsWith('g') ? isGroupId : isEntityId;
  if (!validId(entity.slice(1))) return true;
  if (entity.startsWith('p') && isNumericRouteToken(child, 's')) {
    return !isEntityId(child.slice(1));
  }
  if (/^[dp]/.test(entity) && isNumericRouteToken(child, 'c')) {
    return !entity.startsWith('d') || !isEntityId(child.slice(1));
  }
  return false;
};

export const hasLocalizedSectionRoute = (urlName, poiId, sectionId, locale) => {
  if (typeof urlName !== 'string' || !urlName) return false;
  try {
    const url = new URL(urlName, 'https://www.ticketlens.com');
    if (url.hostname !== 'www.ticketlens.com') return false;
    const prefix = `/p${poiId}/s${sectionId}/`;
    return url.pathname.startsWith(`/${locale}${prefix}`) || url.pathname.startsWith(prefix);
  } catch (_) {
    return false;
  }
};
